<template>
  <div class="form-group" :class="{ 'has-danger': error }">
    <input
      class="form-control"
      :type="type ? type : 'text'"
      :id="'input-text-' + this._uid"
      ref="input"
      :value="value"
      v-on:input="updateValue($event.target.value)"
      :disabled="disabled || !canEdit"
      :maxlength="maxlength"
      :min="min"
      :max="max"
      :placeholder="placeholder"
      :class="{ 'normal': !showLabel }"
      autocomplete="off"
    >
    <under-label v-if="showLabel" :id="'input-text-' + this._uid">
      <slot></slot>
      <span
        v-if="required"
        class="required"
        data-toggle="tooltip"
        data-placement="bottom"
        title="Required"
      >*</span>
    </under-label>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import UnderLabel from "./_UnderLabel.vue";

export default {
  name: "shared-under-input",
  components: {
    UnderLabel
  },
  props: [
    "value",
    "error",
    "required",
    "type",
    "disabled",
    "maxlength",
    "min",
    "max",
    "placeholder",
    "returnArray",
    "hideLabel",
    "disableAutoSave"
  ],
  computed: {
    ...mapGetters({ canEdit: "characters/canEdit" }),
    showLabel() {
      return !this.hideLabel;
    }
  },
  methods: {
    ...mapActions("characters", ["autoSave"]),
    updateValue(value) {
      this.$emit("input", value);
    }
  },
  watch: {
    value() {
      if (!this.disableAutoSave) {
        this.autoSave();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../assets/_global";

.form-control {
  background-color: transparent;
  border-radius: 0 !important;
  border: solid 0px $gray-800;
  border-bottom: solid 1px $gray-400;
  box-shadow: 0 0 0;
  font-size: 1.25em;
  font-weight: bold;
  height: 1.4em !important;
  margin: 0;
  padding: 0;
  text-align: inherit;
  &.normal {
    font-size: 1em;
  }
}
</style>
